import React from "react";

const Home: React.FC = () => {
  return <div><h2>Page Not Found</h2></div>;
};

export default Home;